import { useEffect, FunctionComponent } from 'react'
import styled from 'styled-components'
import { ActivityFile } from 'generated/graphql'
import { KAKAO_INIT_KEY } from 'constants/kakaoDeveloper'

const KakaoButton = styled.div`
  width: 100%;
  height: 100%;
`

export interface KakaoShareButtonProps {
  objectType?: string
  title?: string
  text?: string
  thumbnailImage?: ActivityFile | null
}

export const KakaoShareButton: FunctionComponent<KakaoShareButtonProps> = ({
  objectType = 'feed',
  title = '',
  text = '',
  thumbnailImage,
}) => {
  // const shareButtonRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!(window as any)?.Kakao?.isInitialized()) {
      ;(window as any)?.Kakao?.init(KAKAO_INIT_KEY)
    }
  }, [])

  const handleClick = () => {
    const kakao = (window as any).Kakao

    if (!kakao) {
      return
    }

    switch (objectType) {
      case 'text': {
        kakao.Share.sendDefault({
          objectType: 'text',
          text,
          link: {
            webUrl: window.location.href,
            mobileWebUrl: window.location.href,
          },
        })
        break
      }
      default: {
        kakao.Share.sendDefault({
          objectType: 'feed',
          content: {
            title: `[링커리어] ${title}`,
            imageUrl: thumbnailImage
              ? thumbnailImage.url
              : 'https://linkareer.com/static/images/linkareer.png',
            link: {
              webUrl: window.location.href,
              mobileWebUrl: window.location.href,
            },
          },
        })
        break
      }
    }
  }
  return <KakaoButton onClick={handleClick} />
}
